<div *ngIf="global_texts" class="all-content login">
  <div class="content">
    <div class="inner-content w-100">
      <div class="left-module bloc-image"></div>
      <div class="right-module py-0 px-5 py-lg-5 justify-content-center align-items-center">

        <app-logos-unlogged></app-logos-unlogged>

        <div class="py-4 d-flex flex-column justify-content-center align-items-center">

          <!-- Bubble Title Login -->
          <div class="bubble-step mb-5 bloc-login-form">
            <div class="title">
              <h1 [innerHtml]="page_texts.title"></h1>
            </div>

            <form [formGroup]="reminderForm" (ngSubmit)="onSubmit()">
              <h6 class="mb-3 fw-semi-bold" [innerHtml]="page_texts.text_info"></h6>

              <!-- Email -->
              <div class="mb-4">
                <input class="form-control with-picto email" [attr.placeholder]="page_texts.email"
                       type="text" formControlName="email" autocomplete="new-email">
                <div *ngIf="submitted && reminderForm.controls['email'].errors" class="small fw-bold color-red mt-2">
                  <div
                    *ngIf="reminderForm.controls['email'].errors?.['required']"
                    [innerHtml]="global_texts.error_messages.validator_required">
                  </div>
                  <div
                    *ngIf="reminderForm.controls['email'].errors?.['pattern']"
                    [innerHtml]="global_texts.error_messages.validator_email">
                  </div>
                </div>
              </div>

              <!-- Send Email And Cancel buttons -->
              <div class="d-flex flex-column flex-md-row justify-content-around w-100 gap-3 my-4">
                <button type="button"
                        [routerLink]="'/' + RouterLinks.Login"
                        class="btn btn-solid-red"
                        [innerHtml]="global_texts.cancel"></button>
                <button type="submit" class="btn btn-solid-green" [innerHtml]="global_texts.send"></button>
              </div>
            </form>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
